import axios from 'axios';
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

import { networkCall } from "./Network";

export const fetchDoctorBookings = createAsyncThunk(
  "bookings/fetch",
  async (payload) => {
    const response = await networkCall(
      "GET",
      `/api/clinic_opd/Appointments/slots_taken?clinic_id=${localStorage.getItem("clinic_id")}
      &doctor_id=${payload?.doctorId}&date=${payload?.date}&MDT=CP`
    );
    return response.data;
  }
);

const token = localStorage.getItem("token");
const headers = {
  Authorization: `Bearer ${token}`,
};

export const fetchDoctorBookingsSlots = createAsyncThunk(
  "bookings/fetch",
  async (payload) => {
    const response = await networkCall(
      "GET",
      `/api/clinic_opd/Appointments/datewise_visits?clinic_id=${localStorage.getItem(
        "clinic_id"
      )}&doctor_id=${payload?.doctorId}&date=${payload?.date}&user_role=${localStorage.getItem(
        "user_role"
      )}&MDT=CP`,
      { headers }
    );
    return response.data;
  }
);

export const fetchSchedule = createAsyncThunk(
  "bookings/fetchSchedue",
  async (payload) => {
    const doctorId = payload?.doctorsId || payload?.doctorId;
    const clinicId = payload?.clinic_id || payload?.clinicId || localStorage.getItem('clinic_id');
    const date = payload?.date || '';

    const response = await networkCall(
      "GET",
      `/api/clinic_opd/Doctors/slots?doctor_id=${doctorId}&date=${date}&clinic_id=${clinicId}&MDT=CP`
    );
    if (response.status == '1') {
      return response.data;
    }
    throw new Error("Something Went Wrong");
  }
);

export const addSchedule = createAsyncThunk(
  "bookings/schedule",
  async (payload) => {
    try {
      const formData = new FormData();
      formData.append("array_data", JSON.stringify(payload));
      formData.append("clinic_id", localStorage.getItem('clinic_id'));
      formData.append("user_role", localStorage.getItem('user_role'));
      formData.append('loggedin_user_id', localStorage.getItem('user_id'))
      formData.append("MDT", "CP");

      const token = localStorage.getItem("token");
      const headers = {
        Authorization: `Bearer ${token}`,
      };

      const response = await axios.post(
        global.baseUrl + "/api/clinic_opd/Appointments/add_schedule",
        formData,
        { headers }
      );

      return response.data;
    } catch (error) {
      // axios already throws on HTTP errors (4xx, 5xx)
      if (error.response) {
        throw new Error(error.response.data?.message || `Error: ${error.response.status}`);
      } else {
        // Something else happened
        throw error;
      }
    }
  }
);

// The rest of your slice remains the same
const BookingSlice = createSlice({
  name: "bookings",
  initialState: {
    error: null,
    loading: false,
    bookingList: [],
    slotList: [],
  },
  reducers: {
    mutateSlotList(state, action) {
      console.log(action.payload);
      state.slotList = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchDoctorBookings.pending, (state) => {
        state.loading = true;
        state.bookingList = [];
        state.error = null;
      })
      .addCase(fetchDoctorBookings.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error;
        alert(action?.error);
      })
      .addCase(fetchDoctorBookings.fulfilled, (state, action) => {
        state.loading = false;
        state.bookingList = action.payload;
      });

    builder
      .addCase(addSchedule.pending, (state) => {
        state.loading = true;
      })
      .addCase(addSchedule.rejected, (state, action) => {
        alert(action.error.message);
        state.loading = false;
      })
      .addCase(addSchedule.fulfilled, (state) => {
        state.loading = false;
        alert("Slots Added Successfully");
      });

    builder
      .addCase(fetchSchedule.pending, (state) => {
        state.loading = true;
        state.slotList = [];
      })
      .addCase(fetchSchedule.rejected, (state, action) => {
        state.loading = false;
        alert(action.error?.message || "");
      })
      .addCase(fetchSchedule.fulfilled, (state, action) => {
        state.loading = false;
        state.slotList = action?.payload || [];
      });
  },
});

export const { mutateSlotList } = BookingSlice.actions;
export default BookingSlice.reducer;